export const DEFAULT_SPACE_LOADING_MANAGER_NAME = 'DefaultSpaceLoadingManager' as const;
